import * as React from 'react';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  useTheme,
  Theme
} from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import './CSAllClaims.scss';
import ListSubheader from '@material-ui/core/ListSubheader';
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from '../../../../themes/theme';
import i18n from 'src/translation/i18n';
import iObjCSService from 'src/services/claimStatus/claimStatusService';

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    formControl: {
      margin: themes.spacing(1),
      minWidth: 120,
      maxWidth: 300
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    chip: {
      margin: 2
    },
    noLabel: {
      marginTop: theme.spacing(3)
    }
  })
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
     /* maxHeight: ITEM_HEIGHT * 4.8 + ITEM_PADDING_TOP, */
      width: 'auto',
      minWidth: '150'
    }
  }
};

export default function CSAllClaims(props: any, dProps: any) {
  const classes = useStyles();
  const themes = useTheme();
  // const allClaimsVal =props.getClaimTypes();
  const allClaimsVal = [
    {
      claimType: i18n.t('claimStatus.pFailedAfterInstall'),
      value: 'OC'
    },
    {
      claimType: i18n.t('claimStatus.pDamagedUponArrival'),
      value: 'RC'
    }
  ];
  const disableSearchVal: boolean = false;
  const [personName, setPersonName] = React.useState<string[]>([]);
  const [allClaims, setAllClaims] = React.useState([]);
  const [disableSearch, setdisableSearch] = React.useState(disableSearchVal);
  const { isReset, filter, status } = props;
  const [apiLoader, handleApiLoader] = React.useState(false);

  React.useEffect(() => {
    if (allClaims.length === 0) {
      handleApiLoader(true);
      iObjCSService
        .gClaimTypeLookupData()
        .then((response: any) => {
          const resData = response;
          setAllClaims(resData);
        })
        .catch((error: any) => {
          handleApiLoader(false);
          setAllClaims([]);
        });
    }
  }, []);

  React.useEffect(() => {
    if (isReset) {
      // console.log('Reset Call');
      setPersonName([]);
    }
  }, [isReset]);
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setPersonName(event.target.value as string[]);
    filter(event.target.value);
  };

  const getAllClaims = (val: any, index: number) => {
    return (
      <MenuItem
        key={index}
        value={index === 0 ? '' : val.claimType}
        className="invoices-dropdown"
      >
        {val.claimType}
      </MenuItem>
    );
  };
  return (
    <div className="Invoicefilter-container csFilter1 nopaddingl0 col-md-4 col-sm-6 col-lg-2 col-xs-12">
      <MuiThemeProvider theme={theme}>
        <FormControl className={clsx(classes.formControl, classes.noLabel)}>
          <Select
            displayEmpty={true}
            value={personName}
            onChange={handleChange}
            MenuProps={MenuProps}
            inputProps={{ 'aria-label': 'Without label' }}
            className={
              disableSearch
                ? 'allinvoice-select disable-search'
                : 'allinvoice-select'
            }
          >
            {allClaims &&
              allClaims.map((val: any, index: number) =>
                getAllClaims(val, index)
              )}
          </Select>
        </FormControl>
      </MuiThemeProvider>
    </div>
  );
}
